// extracted by mini-css-extract-plugin
export default {"Error":"ErrorMessage_Error__mEwm2","Error__Ellipsis":"ErrorMessage_Error__Ellipsis__E9Wi7","Error__Button":"ErrorMessage_Error__Button__pNh6C"};